import React, { useState } from "react";
import aside from "../Images/Login-img.png";
import "./CSS/ForgotPassword.css";
import GlobalInput from "../components/CustomInputForgot";
import { validateEmail } from "../Utils/Validation";
import CustomButton from "../components/CustomButtonForgot";
import { useNavigate } from "react-router-dom";
import { VERIFY_EMAIL } from "../Api/apiConstant";
import { usePostAPIMutation } from "../Api/api";
import { toast, ToastContainer } from "react-toastify";
import { useGetAPIWithoutTokenQuery } from "../Api/api";
import { READ_ONE_EVENT } from "../Api/apiConstant";
import { useThemeColors } from "../Context/Theme";
import HomeButton from "../components/HomeButton";
import encryptJSON from "../ServiceModule/Encrypt";
import { isProdEnv, secretEncryptionKey } from "../ServiceModule/Service";

function ForgotPassword() {
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    buttonTextColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors();
  const navigate = useNavigate();
  const eventName = sessionStorage.getItem("eventName");
  const eventId = sessionStorage.getItem("event_id");
  const [Email, setEmail] = useState("");
  const [isEmailValid, setEmailValid] = useState(true);
  const [emailError, setEmailError] = useState(false);

  const [post, { isSuccess, isLoading }] = usePostAPIMutation();
  

  const { data, isError } = useGetAPIWithoutTokenQuery(
    `${READ_ONE_EVENT}${eventId}`
  );
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleEmailVerify = async (e) => {
    
    
    try {
      e.preventDefault();
      let jsonData = {
        user_email: Email.toLowerCase()
      }
      if (isProdEnv == "true") {
        const encryptedPayload = encryptJSON(jsonData, secretEncryptionKey);
        jsonData = {
          element: encryptedPayload,
        }
      }
      const { data } = await post({
        url: VERIFY_EMAIL,
        formData:jsonData,
      });
      toast.success(data.message);
      setTimeout(() => {
        navigate(`/events/${eventName}/verifyOTP`, { state: { email: Email } });
      }, 2000);
    } catch (error) {
      toast.error("Email not Found");
    }
  };

  const navigateToLogin = () => {
    navigate(`/events/${eventName}/login`);
  };

  
    const Theme = useThemeColors();

  return (
    <React.Fragment>
      <ToastContainer limit={1} style={{ zIndex: 999999999999 }}  autoClose={2000} />
      <section className="overflow-hidden">
        <div className="container-fluid">
          <div className="row vh-100">
          <div class="col-sm-6 px-0 py-0 m-0 d-none d-sm-block position-relative">
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: "100vh",
                }}
              >
                <img
                  src={data?.event_img_path ? data?.event_img_path : aside}
                  alt="Login image"
                  className="w-100 vh-100"
                  style={{
                    objectFit: "cover",
                    objectPosition: "left",
                    margin: "0",
                    overflow: "hidden",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                  }}
                ></div>
              </div>

              <div class="overlay-content" style={{ width: "100%" }}>
                <img
                  src={logo}
                  alt="Logo"
                  class="logo"
                  width={218}
                  className="mb-5"
                />
                <p
                  style={{ fontSize: fontSizeHeading || "30px", fontWeight: fontWeightHeading || "700", fontFamily: fontFamilyHeading, width: "100%" }}
                  class="heading"
                >
                  Welcome to ORDER THAT
                </p>
                <p
                  style={{
                    fontSize: fontSize || "19px",
                    fontWeight: fontWeight || "500",
                    textAlign: "center",
                    fontFamily
                  }}
                >
                  You're Tailgate Ready with Order That
                </p>
              </div>
            </div>
            <div
              style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="col-sm-6 text-black"
            >
              <div
                style={{ height: "100vh" }}
                className="d-flex flex-column justify-content-center align-items-center"
              >
                <form
                  onSubmit={(e) => e.preventDefault()} 
                  style={{
                    width: "33rem",
                    height: "27rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    borderRadius: "16px",
                  }}
                >
                  <div style={{ display: 'flex', width:"100%", justifyContent: 'space-between' }}>
                    <p className="login-text fw-bold" style={{fontFamily: fontFamilyHeading, fontSize: fontSizeHeading, fontWeight: fontWeightHeading}}>Reset Password</p>
                  <HomeButton text="Home"/>
                  </div>
                  <br/> 
                  <div style={{ width: "80%" }}>

                  <span className="heading-text" style={{ color: "#828282" }}>
                  Enter your registered email address to receive the OTP for password reset.</span>
                  </div>

                  <div style={{ width: "80%" }}>
                    <div
                      data-mdb-input-init
                      className="form-outline mt-3"
                      style={{ height: "12vh" }}
                    >
                      <GlobalInput
                        type="Email"
                        label="Email"
                        value={Email}
                        onChange={handleEmailChange}
                        placeholder="Enter Registered Email Id"
                        
                        style={{ borderColor: isEmailValid  ? "" : "red" }}
                        required
                        width={"27vw"}
                        onBlur={() => {
                          const isValid = validateEmail(Email);
                          setEmailValid(isValid);
                          setEmailError(!isValid);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            const isValid = validateEmail(Email);
                            setEmailValid(isValid);
                            setEmailError(!isValid);
                        
                            if (isValid) {
                              handleEmailVerify(e);
                            }
                            // No toast here, just trigger state update for error below the input
                          }
                        }}
                             
                   
                      />
                      
                     {emailError && <span className="text-danger" style={{fontSize: "0.8em"}}>Please Enter a valid Email Address
                     </span>}
</div>
                    <div className="">
                      <CustomButton
                        text="Reset Password"
                        size="lg"
                        block={true}
                        onClick={handleEmailVerify}
                        className="mt-2"
                        btnStyle={{}}
                        width={"25vw"}
                        disabled={!isEmailValid || !Email || isLoading || isSuccess}
                      />
                    </div>
                  </div>
                  <p
                    className="welcome-text fs-6 mt-3"
                    style={{
                      color: "#828282",
                      width: "80%",
                      textAlign: "left",
                      fontFamily
                    }}
                  >
                    Remember your password?{" "}
                    <span
                      className="fw-bold"
                      style={{ cursor: "pointer", fontFamily }}
                      onClick={navigateToLogin}
                    >
                      Login
                    </span>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default ForgotPassword;
